import React, { useState, useContext } from "react";
import { AppContext } from "./index";
import CerrarVentana from "./CerrarVentana";

export default function PopupUsuarios({ x, y, setOpen }) {
  let { firebase } = useContext(AppContext);
  const [usuarios, setUsuarios] = useState(firebase.dataUsuarios);

  const Sopciones = {
    position: "fixed",
    top: y,
    left: x,
    fontSize: "12px",
    color: "white",
    margin: "5px",
    zIndex: 5,
    width: "250px",
    background: "white",
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: "5px",
    padding: "5px",
  };

  function consultaUsuarios(e) {
    setUsuarios(firebase.usuarios(e.target.value));
  }

  function drag(e, u) {
    let data = { obj: "usuario", usuario: u }; // guardo la data del usuario
    e.dataTransfer.setData("text", JSON.stringify(data));
  }

  return (
    <div id="filtroPopUpUser" style={Sopciones}>
      <CerrarVentana set={setOpen} />
      <div>
        <input type="text" onChange={(e) => consultaUsuarios(e)} style={{ width: "230px" }} />
      </div>
      <div style={Sfotos}>
        {usuarios.map((u, ind) => (
          <img
            src={u.url}
            alt={u.nombre}
            height="45px"
            width="45px"
            title={u.nombre}
            key={ind}
            onDragStart={(e) => drag(e, u)}
            style={{ clipPath: "circle(50%)" }}
          />
        ))}
      </div>
    </div >
  );
}

const Sfotos = {
  marginTop: "3px",
  display: "grid",
  gridTemplateColumns: "33% 33% 33%",
  gridGap: "5px",
  padding: "10px",
  maxHeight: "220px",
  overflowX: "hidden",
  cursor: "grab",
};
